export enum Profession {
  Architect = 'Architect',
  LandscapeArchitect = 'LandscapeArchitect',
  Geologist = 'Geologist',
}
